import type { KadeweUser } from "~/types";

export default defineNuxtRouteMiddleware((to) => {
    const user = useSanctumUser<KadeweUser>();
    const localePath = useLocalePath();

    if (!user.value?.parking || user.value?.loyalty_status === "royal") {
        console.warn("Parking: User has no access to the parking page, trying to access", to.path);
        return navigateTo(localePath("/portal/card"));
    }
});
